import { useMemo } from 'react';

import { translate } from '@front/i18n';

import { mapOptionsNameToOptionsLabelFormat } from './utils';

const t = translate('screens.professional_status');

export const useWillWorkAsSelfEmployed = (isOptionObjectWithLabel = false) => {
  const willWorkAsSelfEmployedOptions = useMemo(
    () => [
      { name: t('.will_work_as_self_employed.options.yes'), value: 'yes' },
      { name: t('.will_work_as_self_employed.options.no'), value: 'no' },
      { name: t('.will_work_as_self_employed.options.dont_know'), value: 'dont_know' },
    ],
    [],
  );

  const formattedWillWorkAsSelfemployedOptions = isOptionObjectWithLabel
    ? willWorkAsSelfEmployedOptions.map(mapOptionsNameToOptionsLabelFormat)
    : willWorkAsSelfEmployedOptions;

  return formattedWillWorkAsSelfemployedOptions;
};
